(function () {
  'use strict';

  function bindScenePills(slide, onPillClickCallback) {
    var pills = Array.prototype.slice.call(slide.querySelectorAll('[data-scene-pill]'));
    var images = Array.prototype.slice.call(slide.querySelectorAll('[data-scene-image]'));

    pills.forEach(function (pill) {
      pill.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var key = pill.getAttribute('data-scene-key');

        pills.forEach(function (p) {
          var isActive = p === pill;
          p.classList.toggle('is-active', isActive);
          p.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        images.forEach(function (img) {
          img.classList.toggle('is-active', img.getAttribute('data-scene-key') === key);
        });

        // Recalculate dimensions if a pill click updates slide width
        if (typeof onPillClickCallback === 'function') {
          onPillClickCallback();
        }
      });
    });
  }

  function initSceneCarousel(root) {
    var viewport = root.querySelector('.scene-carousel__viewport');
    var track = root.querySelector('[data-scene-track]');
    var prevBtn = root.querySelector('[data-scene-prev]');
    var nextBtn = root.querySelector('[data-scene-next]');

    if (!track || !viewport) return;

    var originalSlides = Array.prototype.slice.call(track.querySelectorAll('[data-scene-slide]'));
    var realCount = originalSlides.length;

    if (realCount === 0) return;

    // Direct callback to handle positioning shifts smoothly if a new tab layout updates width dimensions
    originalSlides.forEach(function (slide) {
      bindScenePills(slide, function () {
        setPosition(false);
      });
    });

    if (realCount <= 1) return;

    var currentIndex = 0;
    var isAnimating = false;
    var allSlides = [];

    function buildClones() {
      Array.prototype.slice.call(track.querySelectorAll('[data-clone="true"]')).forEach(function (el) {
        el.parentNode.removeChild(el);
      });

      // Clone a full pre-set for seamless left looping
      for (var i = 0; i < realCount; i++) {
        var headClone = originalSlides[i].cloneNode(true);
        headClone.setAttribute('data-clone', 'true');
        headClone.setAttribute('aria-hidden', 'true');
        bindScenePills(headClone, function () { setPosition(false); });
        track.insertBefore(headClone, track.firstChild);
      }

      // Clone a full post-set for seamless right looping
      for (var j = 0; j < realCount; j++) {
        var tailClone = originalSlides[j].cloneNode(true);
        tailClone.setAttribute('data-clone', 'true');
        tailClone.setAttribute('aria-hidden', 'true');
        bindScenePills(tailClone, function () { setPosition(false); });
        track.appendChild(tailClone);
      }

      allSlides = Array.prototype.slice.call(track.querySelectorAll('[data-scene-slide]'));
      currentIndex = realCount; 
    }

    function setPosition(withTransition) {
      track.style.transition = withTransition ? 'transform 0.45s cubic-bezier(0.25, 1, 0.5, 1)' : 'none';
      if (allSlides[currentIndex]) {
        var offset = allSlides[currentIndex].offsetLeft;
        track.style.transform = 'translateX(-' + offset + 'px)';
      }
      if (!withTransition) {
        track.offsetHeight; // Force layout engine reflow
      }
    }

    function goTo(index, withTransition) {
      if (isAnimating && withTransition) return;
      if (withTransition) isAnimating = true;
      currentIndex = index;
      setPosition(withTransition);
    }

    track.addEventListener('transitionend', function () {
      isAnimating = false;
      if (currentIndex >= realCount * 2) {
        goTo(currentIndex - realCount, false);
      } else if (currentIndex < realCount) {
        goTo(currentIndex + realCount, false);
      }
    });

    function setup() {
      buildClones();
      goTo(realCount, false);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (isAnimating) return;
        goTo(currentIndex - 1, true);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (isAnimating) return;
        goTo(currentIndex + 1, true);
      });
    }

    // Input Handling (Touch Swipe & Desktop Mouse Dragging)
    var startX = 0;
    var deltaX = 0;
    var isDragging = false;
    var currentTransformOffset = 0;

    function getPointerX(e) {
      return e.touches ? e.touches[0].clientX : e.clientX;
    }

    function onStart(e) {
      if (isAnimating) return;
      if (e.type === 'mousedown' && e.button !== 0) return;
      
      isDragging = true;
      startX = getPointerX(e);
      track.style.transition = 'none';
      
      if (allSlides[currentIndex]) {
        currentTransformOffset = allSlides[currentIndex].offsetLeft;
      }
    }

    function onMove(e) {
      if (!isDragging) return;
      deltaX = getPointerX(e) - startX;
      var targetOffset = currentTransformOffset - deltaX;
      track.style.transform = 'translateX(-' + targetOffset + 'px)';
    }

    function onEnd() {
      if (!isDragging) return;
      isDragging = false;

      if (Math.abs(deltaX) > 60) {
        if (deltaX < 0) {
          goTo(currentIndex + 1, true);
        } else {
          goTo(currentIndex - 1, true);
        }
      } else {
        goTo(currentIndex, true);
      }
      deltaX = 0;
    }

    // Touch listeners
    viewport.addEventListener('touchstart', onStart, { passive: true });
    viewport.addEventListener('touchmove', onMove, { passive: true });
    viewport.addEventListener('touchend', onEnd, { passive: true });

    // Mouse listeners
    viewport.addEventListener('mousedown', onStart);
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onEnd);

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setup, 150);
    });

    // Handle timing safe run logic
    if (document.readyState === 'complete') {
      setup();
    } else {
      window.addEventListener('load', setup);
    }
  }

  function initAll() {
    var carousels = document.querySelectorAll('.scene-carousel');
    Array.prototype.forEach.call(carousels, initSceneCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var rootElement = event.target.querySelector('.scene-carousel');
    if (rootElement) initSceneCarousel(rootElement);
  });
})();